<script>
import logoSrc from '@/assets/ubic-white.svg';
import { menuLinks } from '@/constants';

export default {
  computed: {
    user () {
      return this.$store.state.auth.user || {};
    },
  },
  methods: {
    handleLogout () {
      this.$store.dispatch('auth/logout');
    },
  },
  render () {
    const { $style, user, handleLogout } = this;

    return (
      <nav class={$style.wrapper}>
        <div class={$style.logo}>
          <img
            src={logoSrc}
            alt="UBIC"
          />
        </div>

        <menu class={$style.menu}>
          {menuLinks
            .filter(link => user.permissions.includes(link.permission))
            .map(link => (
              <li
                key={link.to}
                class={$style.menuItem}
              >
                <router-link
                  class={$style.menuLink}
                  to={link.to}
                  exact={Boolean(link.exact)}
                >
                  {link.content}
                </router-link>
              </li>
            ))}
        </menu>

        <div class={$style.user}>
          {user.username}

          <button
            class={$style.userLogout}
            type="button"
            onClick={handleLogout}
          >
            <u-icon name="sign-out" />
          </button>
        </div>
      </nav>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  background-color: $color-primary-darkest;
  color: $color-gray-lighter;
  display: flex;
  height: 3em;
  padding: 0 2em;
}

.logo {
  height: 100%;
  margin-right: 4em;
  padding: .75em 0;

  & > img {
    height: 100%;
  }
}

.menu {
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0;

  &Item {
    display: inline-block;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  &Link {
    align-items: center;
    color: $color-primary-lightest;
    display: inline-flex;
    height: 100%;
    padding: 0 1em;

    &:hover,
    &:focus {
      color: $color-gray;
    }

    &:global(.router-link-active) {
      color: $color-white;
    }
  }
}

.user {
  margin-left: auto;

  &Logout {
    @include button-reset();

    color: $color-primary-lightest;
    margin-left: 1em;

    &:hover,
    &:focus {
      color: $color-gray;
    }
  }
}
</style>
